import moment from 'moment';
import {socket} from '../libs/roomnew';
export default class Timer{
    constructor(
    options={
        seconds:0,
        hostStartDate:new Date(),
        from_id:0,
        from_name: '',
        id:0,
        showCount: false,
        showCountAt: 10,
        playSound: false,
        serverEndTime:null,
        serverStartTime:null
    },
    onUpdate=()=>{},
    onEnd=()=>{}
    ){
        this.worker=URL.createObjectURL(new Blob([`var timer;
        onmessage = function(request) {
            switch (request.data.id) {
            case 1 : {
                timer = setTimeout(() => {
                    postMessage({ id: 3 });
                }, request.data.timeMs);
                break;
            }
            case 2 : {
                if (timer) {
                    clearTimeout(timer);
                }
                break;
            }
            }
        };`], { type: 'application/javascript' }));
        this.hostStartDate=options.hostStartDate;
        this.timerWorker=null;
        this._onTimerMessage;
        this._onTimerMessage=this._onTimerMessage.bind(this);
        this.onUpdate=onUpdate.bind(this);
        this.onEnd=onEnd.bind(this);
        this.codes={
            tick:3,
            start:1,
            end:2
        };
        this.timerSeconds=options.seconds||0;
        this.secondsLeft=0;
        this.id=options.id;
        this.isPaused = false;
        this.from_id = options.from_id;
        this.from_name = options.from_name;
        this.showCount = options.showCount;
        this.showCountAt = options.showCountAt;
        this.playSound = options.playSound;
        this.serverStartTime = options.serverStartTime;
        this.serverEndTime = options.serverEndTime;
    };

    _onTimerMessage(response) {
        if (response.data.id === this.codes.tick) {
            this.secondsLeft--;
            this.onUpdate(this.secondsLeft,this.id);
            if(this.secondsLeft<=0){
                this.stop();
                return;
            }
            this.runTimer();
            this.syncServerTime();
        }
    };
    runTimer(){
       try {
           if(this.isPaused) return;
           this.timerWorker.postMessage({
                id: this.codes.start,
                timeMs: 1000
            });
       } catch (error) {
           
       } 
    }
    async start(from_seconds=0){
        try {
            console.log("run timer from seconds",from_seconds)
            console.log("timer seconds ",this.timerSeconds)
            this.secondsLeft=from_seconds <= 0 ? this.timerSeconds :from_seconds;
            if(!this.serverEndTime){
                await this.setServerTime(this.secondsLeft);
            }
            this.timerWorker = new Worker(this.worker, { name: 'Kino timer' }); 
            this.timerWorker.onmessage=this._onTimerMessage;
            this.runTimer();
            // this.syncServerTime();
        } catch (error) {
            console.error("Kino timer start error",error);   
        }
    };
    async setServerTime(duration){
        let serverTime=await socket.getServerTime();
        if(serverTime){
            this.serverStartTime=moment.utc(serverTime).format("YYYY-MM-DD HH:mm:ss");
            this.serverEndTime=moment.utc(serverTime).add(duration,'seconds').format("YYYY-MM-DD HH:mm:ss");
            console.log(`Server start ${this.serverStartTime} server end ${this.serverEndTime}`);
        }
    };
    async syncServerTime(){
        try {
            if(this.serverEndTime){
                let seconds=await socket.getSecondsTodate(this.serverEndTime);
                // console.log(`Seconds left from server are ${seconds} on JS ${this.secondsLeft}`);
                if(seconds > 0){
                    this.secondsLeft=seconds;
                }
            }
        } catch (error) {
            console.error("sync time error",error);
        }
        
    };
    pause(){
        try{
            this.isPaused = true;
            this.serverEndTime=null;
            this.serverStartTime=null;
            // this.runTimer();
            return this.secondsLeft;
        }catch(err){
            console.error(err);
        }
    }
    resume(){
        try{
            this.isPaused = false;
            this.runTimer();
        }catch(err){
            console.error(err);
        }
    }
    stop(fromUser=false){
        try {
            this.serverEndTime=null;
            this.serverStartTime=null;
            this.timerWorker.postMessage({
                id: this.codes.end
            });
            this.timerWorker.terminate();
            this.onEnd(this.id,fromUser);
        } catch (error) {
            
        }
    };
};